import { IconArrowUpRight } from "@tabler/icons-react";
import instituteImage1 from "../../asserts/ClickMeFox.png";
import instituteImage2 from "../../asserts/ScrollDown.png";
import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";
function InstituteHero() {
  const [showSecondImage, setShowSecondImage] = useState(false);

  return (
    <section
      className="
        relative
        overflow-hidden
        bg-[#f6f6f6]
        px-[14px]
        pb-10
        pt-[115px]
        sm:px-5
        lg:pt-[125px]
      "
    >
      <div
        className="
          relative
          mx-auto
          min-h-[720px]
          max-w-[1320px]
          overflow-hidden
          rounded-[20px]
          bg-transparent
          lg:min-h-[760px]
        "
      >

        {/* =====================================================
            SMALL TOP TEXT
        ===================================================== */}

        <motion.div
          initial={{
            opacity: 0,
            y: -15,
          }}
          animate={{
            opacity: 1,
            y: 0,
          }}
          transition={{
            duration: 0.7,
          }}
          className="
            absolute
            left-6
            top-7
            z-20
            hidden
            items-center
            gap-3
            text-[10px]
            font-bold
            uppercase
            tracking-[0.24em]
            text-neutral-400
            sm:flex
            lg:left-10
            lg:top-9
          "
        >
          <span className="h-[1px] w-8 bg-[#55aef3]" />
          WE3X · Learn Beyond The Classroom
        </motion.div>

        {/* =====================================================
            MAIN HERO LAYOUT
        ===================================================== */}

        <div
          className="
            relative
            z-10
            grid
            min-h-[720px]
            items-center
            gap-10
            px-6
            pb-24
            pt-24
            sm:px-9
            lg:min-h-[760px]
            lg:grid-cols-[0.82fr_1.18fr]
            lg:gap-14
            lg:px-12
            lg:pb-24
            lg:pt-24
            xl:px-16
          "
        >
          {/* =====================================================
              CONTENT
          ===================================================== */}

          <div className="relative z-20">
            <motion.div
              initial={{
                opacity: 0,
                y: 20,
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                duration: 0.7,
                delay: 0.1,
              }}
              className="
                mb-6
                inline-flex
                items-center
                gap-2
                rounded-full
                border
                border-blue-100
                bg-blue-50
                px-4
                py-2
                text-[11px]
                font-bold
                uppercase
                tracking-[0.17em]
                text-[#3899e4]
              "
            >
              <span
                className="
                  h-2
                  w-2
                  animate-pulse
                  rounded-full
                  bg-[#55aef3]
                "
              />
              Your Next Chapter Starts Here
            </motion.div>

            {/* MAIN HEADING */}

            <motion.h1
              initial={{
                opacity: 0,
                y: 35,
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                duration: 0.85,
                delay: 0.18,
                ease: [0.22, 1, 0.36, 1],
              }}
              className="
                max-w-[610px]
                text-[42px]
                font-black
                leading-[1.03]
                tracking-[-0.045em]
                text-[#111111]
                sm:text-[52px]
                lg:text-[59px]
                xl:text-[65px]
              "
            >
              Don't just learn
              <br />
              what's next.
              <span className="block text-[#55aef3]">Be ready for it.</span>
            </motion.h1>

            {/* CATCHY DESCRIPTION */}

            <motion.p
              initial={{
                opacity: 0,
                y: 25,
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                duration: 0.8,
                delay: 0.3,
              }}
              className="
                mt-7
                max-w-[570px]
                text-[15px]
                leading-[1.9]
                text-neutral-600
                sm:text-[16px]
              "
            >
              Curiosity gets you started. Creating something of your own changes
              everything. At WE3X, every course is a space to experiment, make
              mistakes, build ideas and discover what you're capable of.
            </motion.p>

            <motion.p
              initial={{
                opacity: 0,
                y: 25,
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                duration: 0.8,
                delay: 0.4,
              }}
              className="
                mt-4
                max-w-[540px]
                text-[14px]
                font-medium
                leading-7
                text-neutral-800
              "
            >
              You bring the ambition. We'll give you the environment to turn it
              into something real.
            </motion.p>

            {/* SMALL VALUES */}

            <motion.div
              initial={{
                opacity: 0,
                y: 25,
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                duration: 0.8,
                delay: 0.5,
              }}
              className="
                mt-8
                flex
                flex-wrap
                gap-x-6
                gap-y-3
              "
            >
              <HeroPoint text="Explore" />

              <HeroPoint text="Experiment" />

              <HeroPoint text="Create" />

              <HeroPoint text="Grow" />
            </motion.div>

            {/* CTA */}

            <motion.a
              href="#courses"
              initial={{
                opacity: 0,
                y: 25,
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                duration: 0.8,
                delay: 0.6,
              }}
              whileHover={{
                y: -3,
              }}
              className="
                group
                mt-9
                inline-flex
                items-center
                gap-3
                rounded-[9px]
                bg-[#151515]
                px-7
                py-3.5
                text-sm
                font-semibold
                text-white
                shadow-sm
                transition-colors
                hover:bg-[#55aef3]
              "
            >
              Find Your Course
              <IconArrowUpRight
                size={17}
                className="
                  transition-transform
                  duration-300
                  group-hover:translate-x-1
                  group-hover:-translate-y-1
                "
              />
            </motion.a>
          </div>

          {/* =====================================================
              INTERACTIVE IMAGE EXPERIENCE
          ===================================================== */}

          <motion.div
            initial={{
              opacity: 0,
              scale: 0.92,
              x: 40,
            }}
            animate={{
              opacity: 1,
              scale: 1,
              x: 0,
            }}
            transition={{
              duration: 0.4,
              delay: 0.1,
              ease: [0.22, 1, 0.36, 1],
            }}
            className="
              relative
              mx-auto
              w-full
              max-w-[650px]
            "
          >
            <div
              onMouseEnter={() => setShowSecondImage(true)}
              onMouseLeave={() => setShowSecondImage(false)}
              onTouchStart={() => setShowSecondImage(true)}
              onTouchEnd={() => setShowSecondImage(false)}
              className="
    group
    relative
    z-10
    cursor-pointer
    overflow-hidden
    select-none
  "
            >
              <div
                className="
      relative
      aspect-[4/3]
      w-full
      overflow-hidden
    "
              >
                <AnimatePresence mode="wait">
                  {!showSecondImage ? (
                    <motion.img
                      key="first-image"
                      src={instituteImage1}
                      alt="Students learning and collaborating at WE3X Institute"
                      initial={{
                        opacity: 0,
                        scale: 1.04,
                      }}
                      animate={{
                        opacity: 1,
                        scale: 1,
                      }}
                      exit={{
                        opacity: 0,
                        scale: 1.02,
                      }}
                      transition={{
                        duration: 0.5,
                        ease: [0.22, 1, 0.36, 1],
                      }}
                      className=" absolute inset-0 h-full w-full object-contain object-center"
                    />
                  ) : (
                    <motion.img
                      key="second-image"
                      src={instituteImage2}
                      alt="Practical learning session at WE3X Institute"
                      initial={{
                        opacity: 0,
                        scale: 1.04,
                      }}
                      animate={{
                        opacity: 1,
                        scale: 1,
                      }}
                      exit={{
                        opacity: 0,
                        scale: 1.02,
                      }}
                      transition={{
                        duration: 0.5,
                        ease: [0.22, 1, 0.36, 1],
                      }}
                      className=" absolute inset-0 h-full w-full object-contain object-center"
                    />
                  )}
                </AnimatePresence>

                {/* INDEX */}
                <div
                  className=" absolute bottom-5 right-5 z-30 font-mono text-xs font-semibold text-white"
                >
                  {showSecondImage ? "02 / 02" : "01 / 02"}
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        {/* =====================================================
            SCROLL HYPE INDICATOR
        ===================================================== */}

        <motion.a
          href="#courses"
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: 1,
          }}
          transition={{
            duration: 0.8,
            delay: 1,
          }}
          className="
            absolute
            bottom-6
            left-1/2
            z-30
            flex
            -translate-x-1/2
            flex-col
            items-center
            gap-2
            sm:bottom-7
          "
        >
          <span
            className="
              text-[9px]
              font-bold
              uppercase
              tracking-[0.25em]
              text-neutral-400
            "
          >
            Discover what's next
          </span>

          <div
            className="
              relative
              h-10
              w-[1px]
              overflow-hidden
              bg-neutral-200
            "
          >
            <motion.span
              animate={{
                y: [-18, 42],
              }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                ease: "easeInOut",
              }}
              className="
                absolute
                left-0
                top-0
                h-5
                w-[1px]
                bg-[#55aef3]
              "
            />
          </div>
        </motion.a>
      </div>
    </section>
  );
}

/* =========================================================
   HERO POINT
========================================================= */

function HeroPoint({ text }) {
  return (
    <div
      className="
        flex
        items-center
        gap-2
        text-xs
        font-bold
        text-neutral-600
      "
    >
      <span
        className="
          h-1.5
          w-1.5
          rounded-full
          bg-[#55aef3]
        "
      />

      {text}
    </div>
  );
}

export default InstituteHero;
